//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Table from 'react-bootstrap/Table';
///////////////////////////////////////////////////////////   SCSS
import './video-downloads.styles.scss';
///////////////////////////////////////////////////////////   FONTAWESOME
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faArrowCircleDown, faCopy, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';



//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP

class VideoDownloads extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Print Download list
   * @returns JSX dom element
   */
  private printDownloadList = (): JSX.Element => {
    const { mainVideo } = this.props;
    let arr: any[] = [];
    if (mainVideo.linkButtons) {
      mainVideo.linkButtons.forEach((link: any, key: number) => {
        arr.push(
          <td key={'linkBtn_' + key} className='table-cell-btn'>
            {link.isCopy ? (
              <a href={String(window.location)} onClick={(e) => (link.isCopy ? this.copyToClipboard(e, link.url) : null)}>
                <FontAwesomeIcon icon="copy" /> {link.label}
              </a>
            ) : link.download ? (
              <a href={link.url} download={link.download} type={link.type} target={link.target}>
                <FontAwesomeIcon icon="arrow-circle-down" />
                {link.label}
              </a>
            ) : (
              <a href={link.url} type={link.type} target={link.target}>
                <FontAwesomeIcon icon="arrow-circle-right" /> {link.label}
              </a>
            )}
          </td>
        );
      });
    }
    return (
      <tbody>
        <tr>{arr}</tr>
      </tbody>
    );
  };
  /**
   * Copy to clipboard
   * @param e
   * @param txtToCopy
   */
  private copyToClipboard = (e: any, txtToCopy: string): void => {
    e.preventDefault();
    if (!navigator.clipboard) {
      console.error('Depracated copy method needed...');
      return;
    } else {
      navigator.clipboard
        .writeText(txtToCopy)
        .then(() => { })
        .catch(() => { });
    }
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    return (
      <Table>
        <this.printDownloadList />
      </Table>
    );
  }
}
export default VideoDownloads;
